import { makeStyles } from 'tss-react/mui';

import { isLightMode } from 'pages/Landings/utils';

export default makeStyles({ name: 'Logo' })((theme) => {
    return {
        root: {
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            userSelect: 'none',
            textDecoration: 'none'
        },
        text: {
            color: isLightMode(theme) ? '#232323' : '#fff',
            fontSize: 24,
            fontWeight: 500,
            lineHeight: '24px',
            textTransform: 'lowercase'
        }
    };
});
